export default "__VITE_ASSET__xWDCevo$__"